import { createSlice } from "@reduxjs/toolkit";
import { paginatedTexturesSelector } from '../textures/paginatedTexturesSlicer'

export const TAB_NAME = {
  TEXTURES: 'TEXTURES',
  MATERIALS: 'MATERIALS',
  COLORS: 'COLORS',
  PROPERTIES: 'PROPERTIES',
}

export const COLOR_TYPE = {
  HSV: 'HSV',
  RGB: 'RGB',
  HEX: 'HEX',
}

const initialState = {
  selectedTexture: null, // this one is not needed, refactor and try to remove it
  selectedTextureId: null,
  selectedMaterial: null,
  textureFilterOpen: false,
  materialFilterOpen: false,
  activeTab: TAB_NAME.TEXTURES,
  textureFilterValue: [],
  selectedColor: '#ffffff',
  textureInfoOpen: false,
  lastColorChangeMs: null,
  applyTextureInProgress: false,
  colorPickerColorType: COLOR_TYPE.RGB,
  propertiesTabScrollTop: 0,
  
  // custom map selection
  selectMapMode: null,
}

const curatorStylesSlicer = createSlice({
  name: "curatorStyles",
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
    selectTexture: (state, { payload }) => {
      state.selectedTexture = payload;
    },
    setSelectedTextureId: (state, { payload }) => {
      state.selectedTextureId = payload;
    },
    selectMaterial: (state, { payload }) => {
      state.selectedMaterial = payload;
    },
    setSelectMapMode: (state,{ payload}) => {
      state.selectMapMode = payload;
    },
    changeTextureFilterValue: (state, { payload }) => {
      state.textureFilterValue = state.textureFilterValue.includes(payload)
        ? state.textureFilterValue.filter((x) => x !== payload)
        : [...state.textureFilterValue, payload];
    },
    toggleTextureFilterOpen: (state, { payload }) => {
      state.textureFilterOpen =
        typeof payload !== "undefined" ? payload : !state.textureFilterOpen;
    },
    toggleMaterialFilterOpen: (state, { payload }) => {
      state.materialFilterOpen =
        typeof payload !== "undefined" ? payload : !state.textureFilterOpen;
    },
    setActiveTab: (state, { payload }) => {
      state.activeTab = payload;
    },
    setSelectedColor: (state, { payload }) => {
      state.selectedColor = payload;
    },
    setTextureInfoOpen: (state, { payload }) => {
      state.textureInfoOpen = payload
    },
    setApplyTextureInProgress: (state, { payload }) => {
      state.applyTextureInProgress = payload
    },
    setColorPickerColorType: (state, { payload }) => {
      state.colorPickerColorType = payload;
    },
    setPropertiesTabScrollTop: (state, { payload }) => { 
      state.propertiesTabScrollTop = payload;
    }
  },
});

export const {
  selectTexture,
  selectMaterial,
  setActiveTab,
  toggleTextureFilterOpen,
  toggleMaterialFilterOpen,
  changeTextureFilterValue,
  setSelectedColor,
  setSelectMapMode,
  setTextureInfoOpen,
  setSelectedTextureId,
  setApplyTextureInProgress,
  setColorPickerColorType,
  setPropertiesTabScrollTop,
} = curatorStylesSlicer.actions;
export const curatorStyleActions = curatorStylesSlicer.actions;

export const curatorStylesSelector = (state) => state.curatorStyles;
export const curatorStylesReducer = curatorStylesSlicer.reducer;
export default curatorStylesReducer;


export const selectColor = (state) => state.curatorStyles.selectedColor
export const selectTextureInfoOpen = (state) => state.curatorStyles.textureInfoOpen
export const selectActiveTab = (state) => state.curatorStyles.activeTab
export const selectSelectMapMode = (state) => state.curatorStyles.selectMapMode
export const selectLastColorChangeMs = (state) => state.curatorStyles.lastColorChangeMs
export const selectApplyTextureInProgress = (state) => state.curatorStyles.applyTextureInProgress
export const selectIsSelectMapModeActive = (state) => Boolean(state.curatorStyles.selectMapMode); // TODO we might need to check if it's number only
export const selectColorPickerColorType = (state) => state.curatorStyles.colorPickerColorType;
export const selectPropertiesTabScrollTop = (state) => state.curatorStyles.propertiesTabScrollTop;

export const selectSelectedTexture = (state) => {
  const { selectedTexture, selectedTextureId } = state.curatorStyles

  if (!selectedTexture && !selectedTextureId) return null;
  
  if (selectedTextureId) {
    const { list } = paginatedTexturesSelector(state);
    return list.find(t => t.id === selectedTextureId) || null;
  }
  
  return selectedTexture;
}